module.exports = __webpack_public_path__ + "img/1.000f0d98.jpg";